import React from 'react'
import Subsidy_Banner from './subsidy-banner/Subsidy_Banner'
import New_Highlight from './new-highlights/New_Highlight'
import Benefits from './benefits/Benefits'
import Special_State from './special-state/Special_State'
import Free_Consultation from '../home/free-consultation/Free_Consultation'
import Registration_Process from './registration-process/Registration_Process'
import Apply_Now from './apply-now/Apply_Now'

const Subsidy_Policy = () => {
    return (
        <>
            <Subsidy_Banner />
            <New_Highlight />
            <Benefits />
            <Special_State />
            <Free_Consultation />
            <Registration_Process />
            <Apply_Now />
        </>
    )
}

export default Subsidy_Policy